import type { DistributionApiResponse } from '@popety-io/types'
import type { DistributionData, PriceMode } from './DistributionSection.types'
import { processDistributionData } from './DistributionSection.utils'

export const processMarketDistributionData = (
  response: DistributionApiResponse,
  isRental: boolean,
  priceMode?: PriceMode
): DistributionData => {
  const data = processDistributionData(response, isRental, priceMode)
  const buckets = response.by_category?.buckets
  if (!buckets) return data

  const categories = (['Apartment', 'House'] as const).flatMap((category) => {
    const bucket = buckets.find(
      (item) => item.key === category && item.doc_count > 0
    )
    return bucket
      ? [
          {
            category,
            data: processDistributionData(bucket, isRental, priceMode),
          },
        ]
      : []
  })

  return { ...data, categories }
}
